import React, { useEffect, useState } from 'react';
import { cn } from '../lib/utils';
import { Menu, X } from 'lucide-react';
const navItems = [{
  name: 'About',
  href: '#summary'
}, {
  name: 'Competencies',
  href: '#competencies'
}, {
  name: 'Experience',
  href: '#ses-leadership'
}, {
  name: 'Crisis',
  href: '#crisis'
}, {
  name: 'Advisory',
  href: '#boards'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      // Determine active section
      const sections = navItems.map(item => item.href.substring(1));
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-white/5', isScrolled ? 'bg-navy-900/95 backdrop-blur-md py-3' : 'bg-transparent py-6')} data-id="element-313">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-314">
        <a href="#" className="flex flex-col" data-id="element-315">
          <span className="font-heading font-bold text-xl md:text-2xl tracking-tighter text-white uppercase" data-id="element-316">
            Guy C. Beougher
          </span>
          <span className="text-[10px] tracking-[0.2em] text-gold-500 uppercase hidden md:block" data-id="element-317">
            Executive Command
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-318">
          {navItems.map(item => <a key={item.name} href={item.href} className={cn('text-sm font-heading uppercase tracking-widest transition-colors hover:text-gold-500 relative py-2', activeSection === item.href.substring(1) ? 'text-gold-500' : 'text-slate-300')} data-id="element-319">
              {item.name}
              {activeSection === item.href.substring(1) && <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gold-500 shadow-[0_0_8px_rgba(197,165,90,0.5)]" data-id="element-320" />}
            </a>)}
          <a href="#contact" className="ml-4 px-5 py-2 border border-gold-500 text-gold-500 font-heading text-xs uppercase tracking-widest hover:bg-gold-500 hover:text-navy-900 transition-all" data-id="element-321">
            Engage Now
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-322">
          {mobileMenuOpen ? <X data-id="element-323" /> : <Menu data-id="element-324" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-navy-900 border-b border-navy-700 p-4 flex flex-col space-y-4 shadow-xl" data-id="element-325">
          {navItems.map(item => <a key={item.name} href={item.href} className="text-base font-heading uppercase tracking-widest text-slate-300 hover:text-gold-500 py-2 border-b border-white/5" onClick={() => setMobileMenuOpen(false)} data-id="element-326">
              {item.name}
            </a>)}
        </div>}
    </header>;
}